import { twMerge } from "tailwind-merge";

import {
  Table,
  TableData,
  TableHead,
  TableHeader,
  Tag,
} from "~/common/components";
import { getPreviewSuggestionsColors } from "~/providers/utils/getPreviewSuggestionsColors";
import { PotentialAreasOfConcern as PotentialAreasOfConcernType } from "~/providers/utils/types/patientPreviewTypes";

interface PotentialAreasConcernTableProps {
  potentialAreasOfConcern: PotentialAreasOfConcernType[];
}

export const PotentialAreasConcernTable = ({
  potentialAreasOfConcern,
}: PotentialAreasConcernTableProps) => (
  <Table className="rounded-md border">
    <TableHead className="rounded-md">
      <tr>
        <TableHeader className="w-1/3 rounded-l-md">Flag</TableHeader>
        <TableHeader className="rounded-r-md">May suggest</TableHeader>
      </tr>
    </TableHead>
    <tbody className="bg-white text-sm text-gray-70">
      {potentialAreasOfConcern.map(({ flag, suggestions }) => (
        <tr key={flag}>
          <TableData>{flag}</TableData>
          <TableData className="flex gap-2">
            {suggestions.map((suggestion) => (
              <Tag
                key={suggestion}
                className={twMerge(
                  "bg-neutral-5 text-center text-gray-70",
                  getPreviewSuggestionsColors(suggestion),
                )}
              >
                {suggestion}
              </Tag>
            ))}
          </TableData>
        </tr>
      ))}
    </tbody>
  </Table>
);
